module.exports = __webpack_public_path__ + "img/hishamuddin_mouth.78061042.jpg";